<template>
  <div
    ref="images"
    class="images">
    <!-- see if dynamic adding is more performing or load all in the beginning, the last seem to be the best because people will scroll fast -->
    <scroll-image
      v-for="(section, key) in sections"
      :content="section"
      :key="key"
      @image-loaded="imageLoaded"
      @expand-change="onExpandChange" />
  </div>
</template>
<script>

import ScrollImage from 'components/scrollimage/ScrollImage';

export default {
  components: {
    ScrollImage,
  },
  props: {
    scrollPosition: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentImage: 0,
      loadingOffset: 400,
      loadedImages: 0,
      sections: [
        {
          image: 'blocks/other/o1.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
          content: {
            title: 'Art en design',
            people: '887 mensen',
            text: 'Zij werkten aan het plaatje dat je ziet: elke grasspriet, elke berg, alle weereffecten. Alles wat in het spel voorbij komt, is door iemand in elkaar gezet.',
          },
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_veg.svg',
          content: {
            subtitle: 'Bomen en planten',
            text: 'Voor een zo\'n realistisch mogelijke wereld, hebben 12 designers zich specifiek gericht op planten en bomen. 3 designers ontwierpen het water.',
          },
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_vehicle.svg',
          content: {
            subtitle: 'Voertuigen',
            text: '7 designers maakten de koetsen en andere voertuigen.',
          },
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_camp.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_animal.svg',
          content: {
            subtitle: 'Dieren',
            text: 'De game bevat zo\'n 200 verschillende diersoorten. Die zijn ontworpen door een team van 17 designers. Twee van hen waren verantwoordelijk voor alle paarden.',
          },
        },
        {
          image: 'blocks/mens_art_props.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_1.svg',
        },
        {
          image: 'blocks/mens_art_eind.svg',
        },
        {
          image: 'blocks/mens_program_start.svg',
          content: {
            title: 'Programmeurs',
            people: '288 mensen',
            text: 'Om te zorgen dat al die pracht en praal daadwerkelijk functioneert, moeten mensen het programmeren. Sowieso veel werk. Hét technische hoogstandje van Red Dead is de mate van interactie die je als speler hebt met je omgeving. Knap, maar alleen mogelijk dankzij de enorme mankracht die Rockstar ertegenaan heeft gegooid.',
          },
        },
        {
          image: 'blocks/mens_program_1.svg',
        },
        {
          image: 'blocks/mens_program_2.svg',
        },
        {
          image: 'blocks/mens_program_3.svg',
        },
        {
          image: 'blocks/mens_program_1.svg',
        },
        {
          image: 'blocks/mens_program_2.svg',
        },
        {
          image: 'blocks/mens_program_3.svg',
        },
        {
          image: 'blocks/mens_program_1.svg',
        },
        {
          image: 'blocks/mens_program_eind.svg',
        },
        {
          image: 'blocks/mens_test_begin.svg',
          content: {
            title: 'Testers en support',
            people: '658 mensen',
            text: 'Er gaat nogal wat mis bij het maken van een spel. Testers nemen iedere millimeter van het spel onder de loep. Spelen tot je erbij neervalt, bugs eruit halen en wéér testen. In deze categorie zit ook het ondersteunend personeel, zoals office managers en webmasters.',
          },
        },
        {
          image: 'blocks/mens_test_1.svg',
        },
        {
          image: 'blocks/mens_test_1.svg',
        },
        {
          image: 'blocks/mens_test_1.svg',
        },
        {
          image: 'blocks/mens_test_2.svg',
        },
        {
          image: 'blocks/mens_test_3.svg',
        },
        {
          image: 'blocks/mens_test_2.svg',
        },
        {
          image: 'blocks/mens_test_4.svg',
        },
        {
          image: 'blocks/mens_test_2.svg',
        },
        {
          image: 'blocks/mens_test_3.svg',
        },
        {
          image: 'blocks/mens_test_2.svg',
        },
        {
          image: 'blocks/mens_test_4.svg',
        },
        {
          image: 'blocks/mens_test_2.svg',
        },
        {
          image: 'blocks/mens_test_3.svg',
        },
        {
          image: 'blocks/mens_test_2.svg',
        },
        {
          image: 'blocks/mens_test_4.svg',
        },
        {
          image: 'blocks/mens_test_2.svg',
        },
        {
          image: 'blocks/mens_test_1.svg',
        },
        {
          image: 'blocks/mens_test_1.svg',
        },
        {
          image: 'blocks/mens_test_1.svg',
        },
        {
          image: 'blocks/mens_test_eind.svg',
        },
        {
          image: 'blocks/mens_managers_1.svg',
          content: {
            title: 'Managers',
            people: '88 mensen',
            text: '88 managers sturen teams aan op de drie continenten (Noord-Amerika, Europa en Azië) waar het spel is gemaakt. Hier vallen ook regisseurs en art directors onder.',
          },
        },
        {
          image: 'blocks/mens_managers_2.svg',
        },
        {
          image: 'blocks/mens_managers_3.svg',
        },
        {
          image: 'blocks/mens_muziek_1.svg',
          content: {
            title: 'Muziek en geluid',
            people: '157 mensen',
            text: 'Minstens zo belangrijk als het beeld, is het geluid. Niet alleen geluidstechnici, maar ook foley-artiesten (zij maken de omgevingsgeluiden) en muzikanten. Onder meer Josh Homme, de frontman van rockband Queens of the Stone Age, rapper Nas en country-zanger Willie Nelson schreven mee aan de muziek.',
          },
        },
        {
          image: 'blocks/mens_muziek_2.svg',
        },
        {
          image: 'blocks/mens_muziek_3.svg',
        },
        {
          image: 'blocks/mens_muziek_2.svg',
        },
        {
          image: 'blocks/mens_muziek_4.svg',
        },
        {
          image: 'blocks/mens_leveranciers_2.svg',
          content: {
            title: 'Box and content',
            people: '315 mensen',
            text: 'Onbekend, maar niet onbelangrijk. Deze mensen zijn verantwoordelijk voor het doosje, de distributie en de PR. Zij zijn ook de types die de game vertalen en de instructies schrijven.',
          },
        },
        {
          image: 'blocks/mens_leveranciers_1.svg',
        },
        {
          image: 'blocks/mens_leveranciers_2.svg',
        },
        {
          image: 'blocks/mens_leveranciers_3.svg',
        },
        {
          image: 'blocks/mens_leveranciers_1.svg',
        },
        {
          image: 'blocks/mens_leveranciers_2.svg',
        },
        {
          image: 'blocks/mens_leveranciers_2.svg',
        },
        {
          image: 'blocks/mens_leveranciers_3.svg',
        },
        {
          image: 'blocks/mens_leveranciers_eind.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
          content: {
            title: 'Acteurs',
            people: '1409 mensen',
            text: 'En als je na alle ontwerpers, programmeurs en testers dacht dat je iedereen gehad hebt, moet de echte aftiteling nog beginnen. De cast van de game bestaat uit honderden acteurs.',
          },
        },
        {
          image: 'blocks/mens_acteurs_2.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_2.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_2.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_3.svg',
          content: {
            subtitle: 'Figuranten',
            text: 'De grootste groep acteurs: de 640 \'local pedestrians\', figuranten dus.',
          },
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/mens_acteurs_1.svg',
        },
        {
          image: 'blocks/other/o1.svg',
        },
      ],
    };
  },
  methods: {
    getItem(img) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`../assets/img/${img}`);
    },
    onExpandChange(expanded) {
      this.$emit('expand-change', expanded);
    },
    imageLoaded() {
      this.loadedImages += 1;
      if (this.sections.length === this.loadedImages) {
        this.$emit('images-loaded');
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  .images {
    display: flex;
    flex-flow: row nowrap;
    width: auto;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ScrollImages.vue